import React from 'react';
import Box from '../box';
import { RenderOnScreen, vui } from '../core';
import { cs, isJsx } from '../utils';
import Header from './header';
/** Displays Header content appropriate for logged out users, such as sign in button or create account prompt. */
export const LoggedOutHeader = vui((props, ref) => {
    const { children, className, createAccount, logo, mainLinks, signIn, ...rest } = props;
    return (React.createElement(Header, { className: cs('vui-loggedOutHeader', className), ref: ref, ...rest },
        React.createElement(Header.Content, null,
            isJsx(logo) ? logo : React.createElement(Header.Logo, { ...logo }),
            React.createElement(RenderOnScreen, { minWidth: "lg" }, children),
            React.createElement(Box, { ml: "auto" }),
            React.createElement(RenderOnScreen, { minWidth: "lg" },
                isJsx(mainLinks) ? mainLinks : React.createElement(Header.MainLinks, { links: mainLinks }),
                mainLinks !== undefined && React.createElement(Header.Divider, { ml: 1, mr: 3 }),
                isJsx(signIn) ? signIn : React.createElement(Header.SignIn, { ...signIn }),
                isJsx(createAccount) ? createAccount : React.createElement(Header.CreateAccount, { ...createAccount })),
            React.createElement(RenderOnScreen, { maxWidth: "lg" },
                isJsx(signIn) ? signIn : React.createElement(Header.SignIn, { ...signIn }),
                React.createElement(Header.Divider, { ml: 2 }),
                React.createElement(Header.MobileToggle, null),
                React.createElement(Header.MobileContent, null,
                    children,
                    isJsx(createAccount) ? createAccount : React.createElement(Header.CreateAccount, { ...createAccount }),
                    isJsx(mainLinks) ? mainLinks : React.createElement(Header.MainLinks, { links: mainLinks }))))));
});
export default LoggedOutHeader;
